import type { MediaState, Resolvers } from '../../generated/types';
import { mediaStatesMap } from './MediaState.state';

export const resolvers: Resolvers = {
  Mutation: {
    setMediaState: (_, { mediaStateId, mediaState, mediaStateIndex }) => {
      const currentMediaState = mediaStatesMap.get(mediaStateId);
      const newMediaState = [...currentMediaState] as [MediaState];

      const newIndexMediaState = {
        ...currentMediaState[mediaStateIndex],
        ...mediaState,
      };

      newMediaState[mediaStateIndex] = newIndexMediaState;
      mediaStatesMap.set(mediaStateId, newMediaState);
      return newIndexMediaState;
    },
  },
};
